module.exports = __webpack_public_path__ + "static/media/star-1.76bc86a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/star-1.svg
// module id = 1191
// module chunks = 0